import { useLocalPersistedState } from '@neo.tax/shared/hooks';
import { LocalPersistenceKey } from '@neo.tax/shared/types';

import { FilterState } from '../filter-popover.types';
import { ColumnDefinition, Conditions, makeConditionsSchema } from './types';

export const useFilterConditions = <ColumnName extends string>({
  columns,
  initialConditions,
  persistenceKey,
}: {
  columns: readonly ColumnDefinition<ColumnName>[];
  initialConditions?: Conditions<ColumnName>;
  persistenceKey?: LocalPersistenceKey;
}): FilterState<ColumnName> => {
  const defaultConditions: Conditions<ColumnName> = { booleanOperator: 'AND', conditionRows: [] };
  const [conditions, setConditions, resetConditions] = useLocalPersistedState({
    dataSchema: makeConditionsSchema(columns.map((c) => c.name)),
    initialData: initialConditions ?? defaultConditions,
    persistenceKey: persistenceKey ? `filterConditions:${persistenceKey}` : null,
  });

  return {
    columns,
    resetConditions,
    setConditions,
    conditions,
  };
};
